import { api } from "../../utils/api";

export const ResetPasswordUser = async (
  token: string | undefined,
  password: string,
  confirmPassword: string
): Promise<void> => {
  const response = await api.post(
    `/auth-user/reset-password/${token}`,
    { password, confirmPassword }
  );

  return response.data;
};
